import React, { FC, useState } from 'react'
import { Form, Formik, FormikProps } from 'formik'
import {
    ICouponModel,
    initialCoupon,
    ValidationCoupon,
    tabOptions,
    STATUS_OPTIONS,
} from './CouponModel'
import { createCoupon, deleteCoupon, updateCoupon } from './Api'
import { ConfirmModal } from '../../../../shared/components/ConfirmModal'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import FormTabHeader from '../../../../shared/components/FormTabHeader'
import TextInput from '../../../../shared/components/TextInput'
import SelectInput from '../../../../shared/components/SelectInput'
import { showErrorToast, showSuccessToast } from '../../../../shared/components/ToastUtils'

export const CouponPage: FC = () => {
    const [tab, setTab] = useState<string | 'form'>('form')
    const [loading, setLoading] = useState(false)
    const [selectedId, setSelectedId] = useState<string | null>(null)
    const [showModal, setShowModal] = useState(false)


    const handleSave = async (values: ICouponModel, resetForm: () => void) => {
        setLoading(true)
        try {
            if (selectedId) {
                await updateCoupon({ ...values, id: selectedId })
                showSuccessToast('Kupon başarıyla güncellendi')
            } else {
                await createCoupon(values)
                showSuccessToast('Kupon başarıyla oluşturuldu')
            }
            resetForm()
            setSelectedId(null)
            setTab('form')
        } catch (err) {
            showErrorToast('Bir hata oluştu')
        } finally {
            setLoading(false)
        }
    }

    const handleDelete = async () => {
        if (selectedId) {
            try {
                await deleteCoupon(selectedId)
                showSuccessToast('Kupon başarıyla silindi')
            } catch (err) {
                console.error(err)
                showErrorToast('Kupon silinirken bir hata oluştu')
            } finally {
                setShowModal(false)
                setSelectedId(null)
            }
        }
    }

    return (
        <>
            <Formik
                initialValues={initialCoupon}
                validationSchema={ValidationCoupon}
                enableReinitialize
                onSubmit={(values, { resetForm }) => handleSave(values, resetForm)}

            >
                {(formik) => {
                    const handleReset = () => {
                        formik.resetForm();
                        setSelectedId(null);
                    };

                    return (
                        <>
                            <FormTabHeader
                                formId='couponForm'
                                formikSubmit={formik.handleSubmit}
                                formikReset={handleReset}
                                loading={loading}
                                tab={tab}
                                setTab={setTab}
                                setSelectedId={setSelectedId}
                                tabs={tabOptions}
                                onExportExcel={() => console.log('Excel export')}
                            />

                            <div className='card mb-5'>
                                <Form id='couponForm' className='form card-body'>
                                    {tab === 'form' && (
                                        <>
                                            {/* 1. satır: Durum — İskonto */}
                                            <div className='row mb-6'>
                                                <SelectInput
                                                    name='status'
                                                    label='Durum'
                                                    options={STATUS_OPTIONS}
                                                    wrapperClassName='col-md-6'
                                                />
                                                <TextInput
                                                    name='discount'
                                                    type='number'
                                                    label='İskonto'
                                                    min='0'
                                                    step='0.01'
                                                    wrapperClassName='col-md-6'
                                                />
                                            </div>

                                            {/* 2. satır: Kural Adı — Promosyon Kodu */}
                                            <div className='row mb-6'>
                                                <TextInput
                                                    name='ruleName'
                                                    label='Kural Adı'
                                                    wrapperClassName='col-md-6'
                                                />
                                                <TextInput
                                                    name='promotionCode'
                                                    label='Promosyon Kodu'
                                                    wrapperClassName='col-md-6'
                                                />
                                            </div>

                                            {/* 3. satır: Kira Baş./Bit. Tarih */}
                                            <div className='row mb-6'>
                                                <TextInput
                                                    name='rentalStartDate'
                                                    type='date'
                                                    label='Kira Baş. Tarih'
                                                    wrapperClassName='col-md-6'
                                                />
                                                <TextInput
                                                    name='rentalEndDate'
                                                    type='date'
                                                    label='Kira Bit. Tarih'
                                                    wrapperClassName='col-md-6'
                                                />
                                            </div>

                                            {/* 4. satır: Talep Baş./Bit. Saat */}
                                            <div className='row mb-6'>
                                                <TextInput
                                                    name='requestStartDate'
                                                    type='date'
                                                    label='Talep Baş. Tarih'
                                                    wrapperClassName='col-md-6'
                                                />
                                                <TextInput
                                                    name='requestEndDate'
                                                    type='date'
                                                    label='Talep Bit. Tarih'
                                                    wrapperClassName='col-md-6'
                                                />
                                            </div>

                                        </>


                                    )}
                                </Form>
                            </div>
                        </>
                    );
                }}
            </Formik>


            <ConfirmModal
                show={showModal}
                header='Silme Onayı'
                text='Bu kuponu silmek istediğinize emin misiniz?'
                handleClose={() => {
                    setShowModal(false)
                    setSelectedId(null)
                }}
                applyOnClick={handleDelete}
            />

            <ToastContainer
                position='top-right'
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    )
}

export default CouponPage
